export default __webpack_public_path__ + "0b08e5ebb8ce76823e207fe7bcd7187b.svg";